import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AuthService } from '../_services/auth.service';
import { Observable } from 'rxjs';
import { environment } from "../../env.config";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Add api url and locale
        request = request.clone({
            url: `${environment.apiUrl}/` + request.url
        });

        // add authorization header with jwt token if available
        const token = this.authService.tokenValue;
        const isLoggedIn = token && token.access_token;

        if (isLoggedIn) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token.access_token}`
                },
            });
        }

        return next.handle(request);
    }
}
